import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logo from "../../images/logos/logo-horizontal.svg";
import blueLogo from "../../images/logos/logo-horizontal-blue.svg";
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";

export default function Header(props) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("768"));
  const [navOpen, setNavOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const toggleNav = () => {
    setNavOpen(!navOpen);
  };

  useEffect(() => {}, [navOpen]);

  const renderShopButton = () => {
    return (
      <>
        <Button
          aria-controls="simple-menu"
          aria-haspopup="true"
          onClick={handleClick}
          className="shop-dropdown"
          color="primary"
          variant="contained"
          style={{ marginLeft: "20px" }}
          disableElevation={true}
        >
          Shop
        </Button>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          color="secondary"
        >
          <MenuItem onClick={handleClose}>
            <Link to="/shop">Buy Online</Link>
          </MenuItem>
          <MenuItem onClick={handleClose}>
            <Link to="/find-us">Store Locator</Link>
          </MenuItem>
        </Menu>
      </>
    );
  };

  return (
    <header id="header">
      <div className="wrapper">
        <Link
          to="/"
          className={`logo-container ${navOpen ? "hide" : undefined}`}
        >
          <img id="logo" className="logo" src={logo} alt="Brand Logo" />
        </Link>
        <div
          className={`nav-menu ${navOpen ? "close" : "open"}`}
          onClick={toggleNav}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
        <nav id="navigation-container" className={navOpen ? "open" : undefined}>
          <Link className="hide-desktop" to="/">
            <img
              className="mobile-logo"
              src={blueLogo}
              alt="Mobile Brand Logo"
            />
          </Link>

          <Link
            onClick={() => {
              setNavOpen(false);
            }}
            to="/products"
            className={props.activePage === "/products" ? "active" : undefined}
          >
            Products
          </Link>

          <Link
            onClick={() => {
              setNavOpen(false);
            }}
            to="/social-mindsets"
            className={
              props.activePage === "/social-mindsets" ? "active" : undefined
            }
          >
            Social Mindsets
          </Link>
          <Link
            onClick={() => {
              setNavOpen(false);
            }}
            to="/about"
            className={props.activePage === "/about" ? "active" : undefined}
          >
            About
          </Link>

          {isMobile ? (
            <>
              <Link
                onClick={() => {
                  setNavOpen(false);
                }}
                to={"/shop"}
                className={props.activePage === "/shop" ? "active" : undefined}
              >
                Buy Online
              </Link>
              <Link
                onClick={() => {
                  setNavOpen(false);
                }}
                to={"/find-us"}
                className={props.activePage === "/find-us" ? "active" : null}
              >
                Store Locator
              </Link>
            </>
          ) : (
            renderShopButton()
          )}
        </nav>
      </div>
    </header>
  );
}
